

























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { defaultImage } from '@/utils/default'

@Component
export default class extends Vue {
  @Prop({}) private detail
  @Prop({}) private modalDetai

  public name: string = 'profile'
  public data: string = ''
  public array: any = []
  public contains(data) {
    this.array = this.data.split('/')
    return this.array.indexOf(name) > -1
  }
  // public currentImage: string = this.detail.photo === null ? defaultImage : this.detail.photo
}
